export enum ElementType {
  COMPONENT = 0,
  GROUP = 1,
  BLOCK = 2,
  PAGE = 3
}
